import { useQuery } from '@apollo/react-hooks'

import { BankAccount, User } from 'generated/types'

import CheckingFundingQuery from './gql/checking-funding-query.gql'

type CheckingFundingQueryData = {
  user: User
  spendAccounts: BankAccount[]
}

export const useCheckingFundingData = () => {
  const { data, loading } = useQuery<CheckingFundingQueryData>(CheckingFundingQuery, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  })
  const userId = data?.user.uuid
  const accountId = data?.spendAccounts[0]?.id

  return { loading, userId, accountId }
}
